<template>
  <div class="address-list">
    <Empty
      v-if="!address_list.length"
      :empty_type="{ name: '暂无收货地址' }"
      style="margin-top:6.66667vw;"
    />
    <div v-else>
      <div
        class="item"
        v-for="(address, index) in address_list"
        :key="index"
        @click="payChoose(address.id)"
      >
        <img class="icon" src="@/assets/images/book/address.png" alt />
        <div class="info-box">
          <p class="user-box">
            <span class="name">{{ address.user_name }}</span>
            <span class="mobile">{{ address.mobile }}</span>
          </p>
          <p class="address-box">
            <span class="tag" v-if="address.is_default == 1">默认</span>
            <span class="address">
              {{
                address.province_name +
                  address.city_name +
                  address.district_name +
                  address.address
              }}
            </span>
          </p>
        </div>
        <div class="btn" @click.stop="goEdit(2, address.id)">编辑</div>
      </div>
    </div>
    <footer-btn title="添加新地址" @submit="goEdit(1)"></footer-btn>
  </div>
</template>

<script>
export default {
  name: "Address",
  data() {
    return {
      title: {
        name: "收货地址"
      },
      address_list: []
    };
  },
  created() {
    this.getAddress();
  },
  methods: {
    goEdit(type, id) {
      let query = {};
      if (type == 2) {
        //   编辑
        query.id = id;
      }
      this.$router.push({
        name: "AddressEdit",
        query
      });
    },
    async getAddress() {
      this.address_list = await this.$http.get("/api/app/address");
    },
    payChoose(id) {
      if (this.$route.query.payChoose) {
        this.$store.commit("SET_PAY_ADDRESS", id);
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.address-list {
  margin-bottom: 150px;
  .item {
    padding: 24px 30px 30px 30px;
    display: flex;
    align-items: center;
    .icon {
      width: 58px;
      margin-right: 20px;
      flex: none;
    }
    .info-box {
      flex: 1;
      .user-box {
        line-height: 42px;
        .name {
          font-size: 30px;
          color: #20242a;
          margin-right: 12px;
        }
        .mobile {
          font-size: 24px;
          color: #8c8c8c;
        }
      }
      .address-box {
        margin-top: 8px;
        font-size: 24px;
        color: #20242a;
        .address {
          line-height: 30px;
        }
        .tag {
          font-size: 20px;
          color: #e74d3d;
          background-color: rgba(231, 77, 61, 0.06);
          border: 1px solid rgba(231, 77, 61, 0.3);
          border-radius: 8px;
          padding: 0 4px;
          height: 30px;
          margin-right: 7px;
        }
      }
    }
    .btn {
      font-size: 24px;
      color: #e74d3d;
      background-color: rgba(231, 77, 61, 0.06);
      border-radius: 24px;
      padding: 10px 28px;
      white-space: nowrap;
      flex: none;
      margin-left: 50px;
    }
  }
}
</style>
